<template>
  <v-layout row wrap>
    <v-flex xs12>
      <v-card outlined>
        <v-data-table
          :headers="filteredExtrasHeaders"
          :items="extras"
          :search="search"
          item-key="id"
          :items-per-page-options="[10, 25, 50, 100]"
          fixed-header
          :items-per-page="-1"
          ref="extrasDataTable"
          :height="gridHeight"
          sort-by="validFrom"
          sort-desc
          v-model="selected"
          show-select
        >
          <template v-slot:item.actions="{ item }">
            <default-list-actions
              :item="item"
              :hideView="true"
              @deleteItem="deleteItem($event)"
              @editItem="editItem($event)"
              :hide-edit="$store.getters.hasAccessTo('suppliers:view_only')"
              :hide-remove="
                $store.getters.hasAccessTo('suppliers:view_only') ||
                !$store.getters.hasAccessTo('suppliers:delete')
              "
            >
              <template v-slot:extraButton>
                <v-tooltip
                  bottom
                  v-if="!$store.getters.hasAccessTo('suppliers:view_only')"
                >
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      icon
                      small
                      class="mx-0"
                      @click="cloneItem(item)"
                    >
                      <v-icon color="primary" small>mdi-content-copy</v-icon>
                    </v-btn>
                  </template>
                  <span>Copy</span>
                </v-tooltip>
              </template>
            </default-list-actions>
          </template>
          <template v-slot:item.isChildOnly="{ item }">
            <v-checkbox
              v-model="item.isChildOnly"
              @change="updateItem(item)"
            ></v-checkbox>
          </template>
          <template v-slot:item.isInfantOnly="{ item }">
            <v-checkbox
              v-model="item.isInfantOnly"
              @change="updateItem(item)"
            ></v-checkbox>
          </template>
          <template v-slot:item.commission="{ item }">
            <v-checkbox
              v-model="item.commission"
              @change="updateItem(item)"
            ></v-checkbox>
          </template>
          <template v-slot:item.markup="{ item }">
            <v-checkbox
              v-model="item.markup"
              @change="updateItem(item)"
            ></v-checkbox>
          </template>
          <template v-slot:item.discount="{ item }">
            <v-checkbox
              v-model="item.discount"
              @change="updateItem(item)"
            ></v-checkbox>
          </template>
          <template v-slot:item.isMandatory="{ item }">
            <v-checkbox
              v-model="item.isMandatory"
              @change="updateItem(item)"
            ></v-checkbox>
          </template>
          <template v-slot:item.noReport="{ item }">
            <v-checkbox
              v-model="item.noReport"
              @change="updateItem(item)"
            ></v-checkbox>
          </template>
          <template v-slot:item.noVoucher="{ item }">
            <v-checkbox
              v-model="item.noVoucher"
              @change="updateItem(item)"
            ></v-checkbox>
          </template>
          <template v-slot:item.capacityChange="{ item }">
            <v-checkbox
              v-model="item.capacityChange"
              @change="updateItem(item)"
            ></v-checkbox>
          </template>
          <template v-slot:item.marketplace="{ item }">
            <v-checkbox
              v-model="item.marketplace"
              @change="updateItem(item)"
            ></v-checkbox>
          </template>
          <template v-slot:item.validFrom="{ item }">
            {{ item.validFrom | formatDate }}
          </template>
          <template v-slot:item.validTo="{ item }">
            {{ item.validTo | formatDate }}
          </template>
          <template v-slot:item.cost="{ item }">
            {{ item.cost | priceLabeler }}
          </template>
          <template v-slot:item.sell="{ item }">
            {{ item.sell | priceLabeler }}
          </template>
          <template v-slot:footer>
            <v-speed-dial
              v-show="selected.length > 0"
              open-on-hover
              absolute
              direction="right"
              v-model="listFab"
            >
              <template v-slot:activator>
                <v-btn v-model="listFab" color="blue darken-2" dark fab>
                  <v-icon v-if="listFab">mdi-close</v-icon>
                  <v-icon v-else>mdi-menu</v-icon>
                </v-btn>
              </template>
              <v-btn fab dark small color="indigo" @click="onCloneItems">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon small>mdi-content-copy</v-icon>
                  </template>
                  <span>Batch Update</span>
                </v-tooltip>
              </v-btn>
              <v-btn fab dark small color="green" @click="onShowBatchUpdate">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on">mdi-pencil</v-icon>
                  </template>
                  <span>Batch Update</span>
                </v-tooltip>
              </v-btn>
              <v-btn
                fab
                dark
                small
                color="red"
                @click="onDeleteRecords"
                v-if="!hideDelete"
              >
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on">mdi-delete</v-icon>
                  </template>
                  Remove Selected Records
                </v-tooltip>
              </v-btn>
            </v-speed-dial>
          </template>
        </v-data-table>
      </v-card>
    </v-flex>
    <div v-if="debug">extras: {{ selected }}</div>
  </v-layout>
</template>

<script>
import DefaultListActions from "./../../shared/DefaultListActions";

export default {
  name: "SupplierExtrasList",

  components: {
    DefaultListActions,
  },

  props: {
    extras: {
      type: Array,
      default: () => [],
    },
    extrasHeaders: {
      type: Array,
      default: () => [],
    },
    visibleColumns: {
      type: Array,
      default: () => [],
    },
    search: {
      type: String,
      default: "",
    },
  },
  data: () => {
    return {
      debug: false,
      windowHeight: window.innerHeight,
      fixedHeader: true,
      selected: [],
      listFab: false,
    };
  },

  computed: {
    hideDelete() {
      return (
        this.$store.getters.hasAccessTo("suppliers:view_only") ||
        !this.$store.getters.hasAccessTo("suppliers:delete")
      );
    },
    filteredExtrasHeaders() {
      return this.extrasHeaders.filter(
        (h) => this.visibleColumns.indexOf(h.name) > -1
      );
    },
    gridHeight() {
      if (!this.fixedHeader) {
        return null;
      }
      return this.extras && this.extras.length >= 15
        ? this.windowHeight - 500
        : null;
    },
    editableBooleanFields() {
      const fields = [
        "commission",
        "markup",
        "discount",
        "isMandatory",
        "noReport",
        "capacityChange",
        "marketplace",
      ];
      return this.filteredExtrasHeaders.filter((h) => fields.includes(h.name));
    },
  },

  methods: {
    onShowBatchUpdate() {
      console.log("onShowBatchUpdate");
      this.$emit("onBatchUpdate", [...this.selected]);
    },
    updateItem(item) {
      //console.log("updateItem", item);
      this.$emit("onUpdateItem", { ...item });
    },
    cloneItem(item) {
      this.$emit("onCloneItem", { ...item });
    },
    onCloneItems() {
      this.$emit("onCloneItems", [...this.selected]);
    },
    onDeleteRecords() {
      this.$emit("onDeleteRecords", [...this.selected]);
    },
    deleteItem(item) {
      this.$emit("onDeleteItem", { ...item });
    },
    editItem(item) {
      this.$emit("onEditItem", { ...item });
    },
    showColumn(fieldName) {
      return this.visibleColumns.find((name) => name === fieldName);
    },
  },
  mounted() {
    window.addEventListener("resize", () => {
      this.windowHeight = window.innerHeight;
    });
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/gt/suppliers/extras/SupplierExtrasList.vue